import { render } from "./AddImage.vue?vue&type=template&id=0fba8c0d&scoped=true"
import script from "./AddImage.vue?vue&type=script&lang=js"
export * from "./AddImage.vue?vue&type=script&lang=js"

import "./AddImage.vue?vue&type=style&index=0&id=0fba8c0d&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\cymcorp-site\\dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fba8c0d"]])

export default __exports__